/**
 * Alert Component
 * Purpose: Display success, error, or info messages to users
 */

import React from 'react';

const Alert = ({ type, message, onClose }) => {
  // Determine styling based on alert type
  const getAlertClasses = () => {
    switch (type) {
      case 'success':
        return 'bg-green-100 border-green-500 text-green-700';
      case 'error':
        return 'bg-red-100 border-red-500 text-red-700';
      case 'info':
        return 'bg-blue-100 border-blue-500 text-blue-700';
      default:
        return 'bg-gray-100 border-gray-500 text-gray-700';
    }
  };

  if (!message) return null;

  return (
    <div className={`border-l-4 p-4 mb-4 ${getAlertClasses()} relative`}>
      <p className="font-medium">{message}</p>
      {onClose && (
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-2xl font-bold hover:opacity-70"
        >
          &times;
        </button>
      )}
    </div>
  );
};

export default Alert;
